module.exports = __webpack_public_path__ + "img/61ne.b209a083.svg";